import { atom } from 'recoil';

export const ShowSearchBarState = atom({
    key: 'ShowSearchBarState', 
    default: false, 
});